//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

//#region IMR Imports

import { IIMRPopup, IMRPopupOptions, IMRPopupHidingArgs } from '@imr/controls.angularjs/components/overlay/popup'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'

//#endregion

import { Activity, Enums } from '../../../../../../models/common'
import { ColumnInfo } from '../../../../../../models/custom'
import { ColumnModel } from '../../../../../api/api.models'
import { Dictionary, KeyType } from '../../../../../../helpers/dictionary'
import { IAlarmConfigurable, IOpObject, IReferenceType } from '../../../../../../models/util/interfaces'
import { OpAlarmDefGroup, OpAlarmGroup, OpAlarmType, OpDataType, OpView, OpViewColumn } from '../../../../../../models/core'

import { ConfigHelper, ConvertHelper, EventsNames, LocalizationHelper, LogHelper, TemplateHelper, ToastHelper, TypeHelper } from '../../../../../../helpers'
import { AlarmDefinitionService } from '../../../../../../services/alarm-definition'
import { GridService } from '../../../../../../services/grid'
import { PopupHelper } from '../../../../../../helpers/popup-helper'
import { ReferenceTypeService } from '../../../../../../services/reference-type'
import { UserSessionService } from '../../../../../../services/user-session'

import { IAlarmDefinitionsEditOptions, GoAlarmDef } from '../../interfaces/alarm-definitions-edit.interfaces'
import { IAlarmDefinitionGroupRowEdit, IAlarmDefinitionGroupRowEditOptions } from '../../../alarm-definition-group-row-edit/alarm-definition-group-row-edit.interfaces'
import { AlarmDefinitionItemEditOptions, IAlarmDefinitionItemEdit } from '../../../alarm-definition-item-edit/alarm-definition-item-edit.interfaces'
import { IAlarmDefinitionsParameters, AlarmDefinitionsParametersOptions, ParameterValueChangedEventArgs } from '../../../alarm-definitions-parameters/alarm-definitions-parameters.interfaces'
import { ActionStatusOptions } from '../../../../action-status/action-status.controller'
import { ConfirmationOptions } from '../../../../confirmation-popup/confirmation-popup.directive'
import { AlartDefinitionsEditCommonController } from '../alarm-definitions-edit-common/alarm-definitions-edit-common.controller'
import { IMRConfirmationPopupOptions, IMRConfirmationPopupInitializedArgs, IIMRConfirmationPopup, IMRConfirmationPopupResult } from '../../../../confirmation-popup2'

// #region AlarmDefinitionsEditScope

export interface IAlarmDefinitionsBulkEditScope
    extends ng.IScope {
}

// #endregion

export class AlarmDefinitionsSingleEditController
    extends AlartDefinitionsEditCommonController
    implements ng.IComponentController {

    // #region Consts

    public addAlarmGroupButtonTargetId = 'addAlarmGroupButton_' + TypeHelper.guid()

    // #endregion

    // #region Members

    //#region input parameters

    private options: IAlarmDefinitionsEditOptions

    //#endregion

    public addAlarmGroupButtonOptions: DevExpress.ui.dxButtonOptions
    public alarmDefParamsOptions: AlarmDefinitionsParametersOptions
    public applyChangesButtonOptions: DevExpress.ui.dxButtonOptions
    public deleteAlarmGroupButtonOptions: DevExpress.ui.dxButtonOptions
    public addAlarmGroupPopoverOptions: DevExpress.ui.dxPopoverOptions
    public id: number = new Date().getTime()
    public sendObjectConfigurationOptions: DevExpress.ui.dxButtonOptions

    private addAlarmGroupPopover: DevExpress.ui.dxPopup
    private alarmDefParams: IAlarmDefinitionsParameters
    private alarmGroupPopoverAddAlarmGroupButton: DevExpress.ui.dxButton
    private alarmGroupPopoverAddAlarmGroupButtonOptions: DevExpress.ui.dxButtonOptions
    private availableAlarmGroupsSelectBox: DevExpress.ui.dxSelectBox
    private availableAlarmGroupsSelectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    private canEditAlarmGroup: boolean
    private dataSource: IAlarmConfigurable
    private deleteAlarmGroupButton: DevExpress.ui.dxButton
    private hasChanges: boolean
    private imrPopup: IIMRPopup
    private imrPopupOptions: IMRPopupOptions
    private isHidingCanceled: boolean
    private referenceObjectReferenceTypeName: string
    private selectedNewAlarmGroup: OpAlarmGroup

    // #endregion

    // #region Ctor

    constructor(
        private $scope: IAlarmDefinitionsBulkEditScope,
        private userSessionService: UserSessionService,
        protected alarmDefinitionService: AlarmDefinitionService,
        private gridService: GridService,
        private referenceTypeService: ReferenceTypeService
    ) {
        super(alarmDefinitionService)

        this.initializePopupOptions()

    }

    //#region Ctor


    //#endregion


    //#region IComponentController Implementation

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.showPopup()
            this.initialize()
        }
    }

    //#endregion

    // #endregion

    // #region IAlarmDefinitionsEdit

    public showPopup(): void {
        if (this.popupExists()) {
            this.imrPopup.show()
        } else {
            LogHelper.error(AlarmDefinitionService.LOG_PREFIX, `Can't show popup - popup doesn't exist`)
        }
    }

    private hidePopup(): void {
        if (this.popupExists()) {
            this.imrPopup.hide()
        } else {
            LogHelper.error(AlarmDefinitionService.LOG_PREFIX, `Can't hide popup - popup doesn't exist`)
        }
    }

    private setDataSource(dataSource: IAlarmConfigurable): void {
        if (dataSource == null) {
            return
        }

        this.dataSource = dataSource

        if (this.areAlarmDefParamsVisible()
            && TypeHelper.isIOpObject(<any>this.dataSource)
            && this.alarmDefParams != null
        ) {
            this.alarmDefParams.setDataSource(<any>this.dataSource)
        }

        this.setAlarmDefs(dataSource.currentAlarmDefs)
    }

    public showLoader(): void {
        this.imrPopup.toggleLoading(true)
    }

    public hideLoader(): void {
        this.imrPopup.toggleLoading(false)
    }

    // #endregion

    // #region Lifecycle     

    private hiding(e: any): void {
        if (e != null && this.hasChanges && !this.isHidingCanceled) {
            e.cancel = true

            this.isHidingCanceled = true

            const confirmationOptions: ConfirmationOptions = {
                title: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendTheConfiugrationToThe)} ${this.referenceObjectReferenceTypeName}`,
                question: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefinitionsWereUpdatedToYouWantToSendConfiugrationTo)} ${this.referenceObjectReferenceTypeName}`,
                onConfirmed: () => {
                    this.setInitialButtonStats()
                    this.sendConfiguration()
                    this.hidePopup()
                    this.onHidden()
                },
                onDeclined: () => {
                    this.setInitialButtonStats()
                    this.hidePopup()
                    this.onHidden()
                },
            }

            this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.id, confirmationOptions)
        } else {
            this.setInitialButtonStats()
            this.hidePopup()
            this.onHidden()
        }
    }

    private initialize(): void {
        this.showLoader()

        this.initializeCommon()
        this.initializeConfirmationPopup()
        this.setCommonOptions()

        this.setFields()
        this.setOptions()

        this.setDictionaries()
            .then(() => {
                this.setDataSource(this.options.referenceObject as IAlarmConfigurable)
                this.hideLoader()
            })
    }

    // #endregion

    // #region Events

    private onHidden(): void {
        this.alarmDefPopoverVisible = false
    }

    private onApplyChangesClick(args: any): void {
        if (this.validateAlarmParametersData() && this.validateAlarmDefData()) {
            this.isSaveEnabled = false
            this.isSendToReferenceObjectEnabled = false

            this.save()
        }
    }

    private onSendObjectConfigurationClick(args: any): void {
        const confirmationOptions: ConfirmationOptions = {
            title: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendTheConfiugrationToThe)} ${this.referenceObjectReferenceTypeName}`,
            question: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AreYouSureYouWantToSendConfiugrationTo)} ${this.referenceObjectReferenceTypeName}`,
            onConfirmed: () => { this.onSendObjectConfigurationConfirmed() },
            onDeclined: () => { },
        }

        this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.id, confirmationOptions)
    }

    private onSendObjectConfigurationConfirmed(): void {
        this.sendConfiguration()
            .then(() => {
                this.isSendToReferenceObjectEnabled = false
            })
            .fail((error: any) => {
                const errorMessage: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMessage || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
            })
    }

    private onAddAlarmGroupPopoverInitialized(args: any): void {
        this.addAlarmGroupPopover = args.component
    }

    private onAlarmGroupPopoverAddAlarmGroupButtonInitialized(args: any): void {
        this.alarmGroupPopoverAddAlarmGroupButton = args.component
    }

    private onAlarmGroupPopoverAddAlarmGroupButtonClick(): void {
        if (this.selectedNewAlarmGroup != null) {
            this.alarmGroupsPossibleToAdd.splice(_.findIndex(this.alarmGroupsPossibleToAdd, (alarmGroup: OpAlarmGroup) => alarmGroup.idAlarmGroup === this.selectedNewAlarmGroup.idAlarmGroup), 1)

            this.addNewAlarmGroup(this.selectedNewAlarmGroup)

            this.addAlarmGroupPopover.toggle(false)
        }
    }

    private onAvailableAlarmGroupsSelectBoxSelectionChanged(args: any): void {
        this.selectedNewAlarmGroup = args.selectedItem
    }

    private onAvailableAlarmGroupsSelectBoxInitialized(args: any): void {
        this.availableAlarmGroupsSelectBox = args.component
    }

    private onDeleteAlarmGroupButtonInitialized(args: any): void {
        this.deleteAlarmGroupButton = args.component
    }

    private onAddAlarmGroupButtonClick(args: any): void {
        this.addAlarmGroupPopover.toggle(true)
    }

    private onAlarmDefParamsOptionsInitialized(controller: IAlarmDefinitionsParameters): void {
        this.alarmDefParams = controller
    }

    private onAlarmDefParamsParameterChanged(args: ParameterValueChangedEventArgs): void {
        if (args == null) {
            return
        }

        if (this.dataSource != null && TypeHelper.isIOpObject(this.dataSource)) {
            const opObject: IOpObject = <IOpObject><any>this.dataSource
            opObject.dataList.setValue(args.newValue, args.idDataType, args.indexNbr)
        }

        this.setButtonsStates()
    }

    private onAlarmConfigurableSaved(): void {
        if (this.optionsExists() && this.options.onAlarmConfigurableSaved != null) {
            this.options.onAlarmConfigurableSaved(this.dataSource)
        }
    }

    // #endregion

    // #region Setup    

    private setFields(): void {
        this.alarmDefParamsOptions = null

        this.alarmDefPopoverVisible = false
        this.canEditAlarmGroup = this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_GROUP_EDIT)
        this.referenceObjectReferenceTypeName = LocalizationHelper.getLocalizedText(`To${Enums.SimaxModuleName[this.options.moduleName]}`)
    }

    private setOptions(): void {

        this.alarmDefParamsOptions = {
            referenceType: this.options.referenceType,
            moduleName: this.options.moduleName,

            onInitialized: (controller: IAlarmDefinitionsParameters) => { this.onAlarmDefParamsOptionsInitialized(controller) },
            onParameterValueChanged: (args: ParameterValueChangedEventArgs) => { this.onAlarmDefParamsParameterChanged(args) }
        }

        this.sendObjectConfigurationOptions = {
            template: TemplateHelper.getIconWithText(`${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationTo)} ${this.referenceObjectReferenceTypeName}`, ConfigHelper.Icon.DEVICES, this.userSessionService),
            bindingOptions: { disabled: '!$ctrl.isSendToReferenceObjectEnabled' },
            onClick: (args: any) => { this.onSendObjectConfigurationClick(args) }
        }

        this.applyChangesButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),
            bindingOptions: { disabled: '!$ctrl.isSaveEnabled' },
            onClick: (args: any) => { this.onApplyChangesClick(args) }
        }

        this.addAlarmGroupButtonOptions = {
            template: TemplateHelper.getIconWithAdditionalIcon(ConfigHelper.Icon.ALARM_GROUPS, ConfigHelper.Icon.ADD, this.userSessionService),
            bindingOptions: { disabled: '!$ctrl.canEditAlarmGroup' },
            onClick: (args: any) => { this.onAddAlarmGroupButtonClick(args) }
        }

        this.deleteAlarmGroupButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE, this.userSessionService, { iconSize: Enums.SimaxIconSize.Small }),
            bindingOptions: { disabled: '!$ctrl.canEditAlarmGroup' },
            onInitialized: (args: any) => { this.onDeleteAlarmGroupButtonInitialized(args) }
        }

        this.addAlarmGroupPopoverOptions = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.GroupEdit, { collection: 'Popup' }),
            target: '#' + this.addAlarmGroupButtonTargetId,
            onInitialized: (args: any) => { this.onAddAlarmGroupPopoverInitialized(args) },
        }

        this.availableAlarmGroupsSelectBoxOptions = {
            bindingOptions: { items: '$ctrl.alarmGroupsPossibleToAdd' },
            searchEnabled: true,
            displayExpr: 'name',
            width: 250,
            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
            onInitialized: (args: any) => { this.onAvailableAlarmGroupsSelectBoxInitialized(args) },
            onSelectionChanged: (args: any) => { this.onAvailableAlarmGroupsSelectBoxSelectionChanged(args) }
        }

        this.alarmGroupPopoverAddAlarmGroupButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.ADD, this.userSessionService),
            onInitialized: (args: any) => { this.onAlarmGroupPopoverAddAlarmGroupButtonInitialized(args) },
            onClick: (args: any) => { this.onAlarmGroupPopoverAddAlarmGroupButtonClick() }
        }
    }

    private setDictionaries(): JQueryPromise<void> {
        const dataTypeGroupOptions: any = {
            skipView: true,
            groupReferenceType: Enums.ReferenceType.IdDistributor,
            groupReferenceValue: this.userSessionService.getLoggedOperator().idDistributor
        }

        const alarmGroupDeferred: JQueryDeferred<OpAlarmGroup[]> = $.Deferred<OpAlarmGroup[]>()

        const promises: JQueryPromise<any>[] = [
            this.gridService
                .getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ALARM_DEF_PARAMS,
                    this.options.moduleName,
                    dataTypeGroupOptions
                ),
            this.gridService
                .getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ALARM_DEF_REF_PARAMS,
                    this.options.moduleName,
                    dataTypeGroupOptions
                ),
            this.userSessionService
                .getDataProvider()
                .System
                .getDictionaries([Enums.ReferenceType.IdAlarmType, Enums.ReferenceType.IdDataType]),
            alarmGroupDeferred.promise()
        ]

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_GROUP_LIST)) {
            this.userSessionService
                .getDataProvider()
                .View
                .getActiveView(Enums.ReferenceType.IdAlarmGroup)
                .then((view: OpView) => {
                    if (view != null) {
                        const columns: ColumnInfo[] = []
                        const pkVColumn: OpViewColumn = view.getPrimaryKeyColumn()

                        const pkColumnInfo: ColumnInfo = new ColumnInfo(null)

                        pkColumnInfo.IdDataType = pkVColumn.idDataType
                        pkColumnInfo.Name = pkVColumn.name

                        columns.push(pkColumnInfo)

                        this.userSessionService
                            .getDataProvider()
                            .AlarmGroup
                            .getAlarmGroupFilter(columns, 1, TypeHelper.MAX_INT_VALUE, null)
                            .then((result: any) => {
                                const alarmGroups: OpAlarmGroup[] = result == null || result.objects == null
                                    ? null
                                    : result.objects.map((alarmGroup: any) => <OpAlarmGroup>alarmGroup)

                                alarmGroupDeferred.resolve(alarmGroups)
                            })
                    }
                })
        } else {
            alarmGroupDeferred.resolve(null)
        }

        return $.when<any>(
            ...promises
        )
            .then((alarmDefParams: ColumnModel[], alarmDefRefParams: ColumnModel[], dicts: Dictionary<Dictionary<IReferenceType>>, alarmGroups: OpAlarmGroup[]) => {
                this.alarmDefParamsColumns = alarmDefParams || []
                this.alarmDefRefParams = alarmDefRefParams || []

                this.alarmDefParamsExist = this.alarmDefParamsColumns.length > 0
                this.setAlarmDefTagBoxAcceptCustomValues(this.alarmDefParamsExist)

                this.alarmTypes = (
                    this.referenceTypeService.extractReferenceTypeDictionary(dicts, Enums.ReferenceType.IdAlarmType, (item: OpAlarmType) => item.idAlarmType)
                    || new Dictionary<OpAlarmType>(null, KeyType.Number)
                ).values()

                this.dataTypes = (
                    this.referenceTypeService.extractReferenceTypeDictionary(dicts, Enums.ReferenceType.IdDataType, (item: OpDataType) => item.idDataType)
                    || new Dictionary<OpDataType>(null, KeyType.Number)
                ).values()

                this.alarmGroups = alarmGroups || []
            })
    }

    // #endregion


    // #region Flags   

    public areAlarmDefParamsVisible(): boolean {
        return !this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_DEF_EDIT_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.AlarmDefParams)
    }

    public isRegionFullSize(): boolean {
        return !this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_GROUP_LIST)
            || this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_DEF_EDIT_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.AlarmGroup)
    }

    public isSendConfigurationButtonVisible(): boolean {
        return this.optionsExists()
            && this.options.configurationReferenceObject != null
            && this.userSessionService.getLoggedOperator().hasPermission(this.options.sendConfigurationIdActivity)
    }

    public isGroupsEditVisible(): boolean {
        return this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_GROUP_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_DEF_EDIT_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.AlarmGroup)
    }

    public isGroupEditVisible(options: AlarmDefinitionItemEditOptions): boolean {
        return this.alarmTypes != null
            && this.alarmTypes.length > 0
            && options != null
    }

    private popupExists(): boolean {
        return this.imrPopup != null
    }

    private optionsExists(): boolean {
        return this.options != null
    }

    // #endregion


    // #region AlarmDefinitionsEditController

    public deleteAlarmGroup(alarmGroup: OpAlarmGroup): void {
        const groupIndex: number = this.currentAlarmGroups.indexOf(alarmGroup)

        this.currentAlarmGroups.splice(groupIndex, 1)

        this.alarmGroupsPossibleToAdd = _.sortBy(this.alarmGroupsPossibleToAdd.concat([alarmGroup]), (group: OpAlarmGroup) => group.name)

        this.currentAlarmDefs.forEach((alarmDef: GoAlarmDef) => {
            if (alarmDef.alarmDef.currentAlarmDefGroups != null) {

                _
                    .chain(alarmDef.alarmDef.currentAlarmDefGroups)
                    .filter((alarmDefGroup: OpAlarmDefGroup) => {
                        return alarmDefGroup.idAlarmGroup === alarmGroup.idAlarmGroup
                    })
                    .forEach((alarmDefGroup: OpAlarmDefGroup) => {
                        alarmDefGroup.opState = Enums.OpChangeState.Delete
                    })
            }

            this.setAlarmDefChangeState(alarmDef.alarmDef)
        })

        const alarmGroupEditOptions: IAlarmDefinitionGroupRowEditOptions[] = []

        this.currentAlarmDefs.forEach((alarmDef: GoAlarmDef) => {
            alarmGroupEditOptions.push(this.createAlarmGroupRowEditOptions(alarmDef.alarmDef))
        })

        this.alarmGroupEditOptions = alarmGroupEditOptions

        this.setButtonsStates()
    }

    private save(): JQueryPromise<IAlarmConfigurable> {
        this.showLoader()

        this.dataSource.currentAlarmDefs = this.currentAlarmDefs.map((alarmDef: GoAlarmDef) => alarmDef.toOpAlarmDef())

        return this.referenceTypeService
            .saveReferenceObject(this.dataSource)
            .then((referenceType: IReferenceType) => {
                this.setDataSource(<IAlarmConfigurable>referenceType)
                this.onAlarmConfigurableSaved()

                this.isSaveEnabled = false
                this.isSendToReferenceObjectEnabled = true

                ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefinitionsSaved))

                return this.dataSource
            })
            .fail((error: any) => {
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
            })
            .always(() => {
                this.hideLoader()
            })
    }

    private addNewAlarmGroup(alarmGroup: OpAlarmGroup): void {
        if (alarmGroup == null) { return }

        this.currentAlarmGroups.push(alarmGroup)

        if (this.alarmGroupEditControllers == null) {
            this.alarmGroupEditControllers = []
        }

        this.alarmGroupEditControllers.forEach((ctrl: IAlarmDefinitionGroupRowEdit) => {
            ctrl.repaint()
        })
    }

    private validateAlarmDefData(): boolean {
        return _
            .chain(this.alarmDefItemEditControllers)
            .map((alarmDefItemEdit: IAlarmDefinitionItemEdit) => {
                return alarmDefItemEdit.validateAlarmDefData()
            })
            .every((isValid: boolean) => {
                return isValid
            })
            .value()
    }

    private validateAlarmParametersData(): boolean {
        if (this.alarmDefParams != null) {
            return this.alarmDefParams.validateFormData()
        }

        return true
    }

    // #endregion


    // #region Confirmation Popup

    public confirmationPopupOptions: IMRConfirmationPopupOptions
    private confirmationPopup: IIMRConfirmationPopup

    private initializeConfirmationPopup(): JQueryPromise<any> {
        this.confirmationPopupOptions = {
            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.confirmationPopup = e.component
            }
        }

        return TypeHelper.onInitializedAll(this.confirmationPopupOptions)
    }

    //#endregion


    //#region Condifiguration

    private sendConfiguration(): JQueryPromise<ActionStatusOptions> {
        if (this.optionsExists()
            && this.options.sendConfiguration != null
            && this.options.configurationReferenceObject != null
        ) {
            return this.options.sendConfiguration(this.userSessionService.getDataProvider(), [this.options.configurationReferenceObject])
        }

        return $.Deferred<ActionStatusOptions>().resolve(null).promise()
    }

    //#endregion


    //#region Popup

    private initializePopupOptions(): void {
        this.imrPopupOptions = {
            innerOptions: PopupHelper.mergeWithDefaultOptions({
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefinitionEdit),

                width: '100%',
                height: '100%',
            }),

            onHiding: (e: IMRPopupHidingArgs) => {
                this.onPopupHiding(e)
            },

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.imrPopup = e.component
            }
        }
    }

    private onPopupHiding(e: IMRPopupHidingArgs): void {
        if (this.isSendConfigurationButtonVisible() && this.options.sendConfiguration != null && this.options.configurationReferenceObject != null && this.isSendToReferenceObjectEnabled === true) {
            e.cancelAsync = this.confirmationPopup
                .show({
                    title: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendTheConfiugrationToThe)} ${this.referenceObjectReferenceTypeName}`,
                    content: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefinitionsWereUpdatedToYouWantToSendConfiugrationTo)} ${this.referenceObjectReferenceTypeName}`,

                    onConfirmed: () => {
                        this.setInitialButtonStats()
                        this.sendConfiguration()
                        this.onHidden()
                    },

                    onDeclined: () => {
                        this.setInitialButtonStats()
                        this.onHidden()
                    },
                })
                .then((result: IMRConfirmationPopupResult) => {
                    return false
                })
        }
        else {
            this.setInitialButtonStats()
            this.onHidden()
        }
    }

    //#endregion

}
